<script setup lang="ts">
import { useDark } from '@vueuse/core'

import sidebarIcon from '@/assets/svg/sidebar-icon.svg'

defineProps<{
  isExpanded: boolean
}>()

const emit = defineEmits<{
  toggle: []
}>()

const isDark = useDark()
</script>

<template>
  <button
    @click="emit('toggle')"
    class="w-8 h-8 mt-1 cursor-pointer flex mx-auto items-center justify-center rounded-full transition-all duration-300 ease-in-out z-10"
    :class="
      isDark
        ? 'text-(--p-primary-color) hover:bg-(--p-primary-color)/10 hover:text-(--p-primary-color)'
        : 'text-(--p-primary-color) hover:bg-(--p-primary-color)/10 hover:text-(--p-primary-color)'
    "
  >
    <sidebarIcon width="14" />
  </button>
</template>
